export default __webpack_public_path__ + "d793847884092aa8c79a20ea289bfe2f.ttf";